export type EmailAddress = {
  name?: string | null;
  address?: string | null;
};

export type EmailRecipient = {
  emailAddress?: EmailAddress | null;
};

export type OriginalEmailData = {
  subject?: string | null;
  from?: EmailRecipient | null;
  toRecipients?: EmailRecipient[] | null;
  ccRecipients?: EmailRecipient[] | null;
  bccRecipients?: EmailRecipient[] | null;
  sentDateTime?: string | null;
  receivedDateTime?: string | null;
};

export function formatEmailRecipient(recipient?: EmailRecipient | null): string {
  const name = recipient?.emailAddress?.name?.trim() || "";
  const address = recipient?.emailAddress?.address?.trim() || "";
  if (name && address) return `${name} <${address}>`;
  return name || address;
}

export function escapeHtml(value: string): string {
  return value
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");
}

export function isHtmlEmailContent(contentType?: string | null): boolean {
  const type = contentType?.trim().toLowerCase() ?? "";
  if (!type) return true;
  return type.includes("html");
}

/** Isolated document so original email HTML stays inside the dialog window. */
export function buildOriginalEmailDocument(
  content: string,
  contentType?: string | null,
): string {
  const html = isHtmlEmailContent(contentType);
  const inner = html ? content : `<pre>${escapeHtml(content)}</pre>`;

  return `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<base target="_blank" rel="noopener">
<style>
  html, body {
    margin: 0;
    padding: 0;
    background: #ffffff;
    color: #1f1f1f;
  }
  body {
    font-family: "Segoe UI", Tahoma, sans-serif;
    font-size: 14px;
    line-height: 1.5;
    overflow: auto;
    overflow-wrap: anywhere;
    word-break: break-word;
    ${html ? "" : "padding: 16px 20px;"}
  }
  img, svg, video { max-width: 100%; height: auto; }
  pre, code {
    margin: 0;
    white-space: pre-wrap;
    word-break: break-word;
    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
    font-size: 12px;
  }
</style>
</head>
<body>${inner}</body>
</html>`;
}
